import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EPossibleActionsEnum } from '@core/enum/possible-actions-enum';
import { ColumnItem } from '@core/interface/column-item';
import { HandleActionDto } from '@core/interface/handle-action-dto';
import { QueryParamsItem } from '@core/interface/query-params-item';
import { TableStateDto } from '@core/interface/table-state-dto';
import { FeatureFlagsService } from '@core/service/feature-flags/feature-flags.service';
import { UtilService } from '@core/service/util.service';

@Component({
  selector: 'ldc-crud',
  templateUrl: './crud.component.html',
  styleUrl: './crud.component.scss'
})
export class CrudComponent<T> implements OnInit {
  @Input() title: string;
  @Input() tableState: TableStateDto<T>;
  @Input() columns: ColumnItem[] = [];
  @Input() drawerClosed: EventEmitter<boolean> = new EventEmitter();
  @Input() crudEnabled: boolean = false;
  @Input() syncEnabled: boolean = false;
  @Input() externalLoadingState = false;
  @Input() syncLoadingChange: EventEmitter<boolean> = new EventEmitter();
  @Output() queryParamsChange = new EventEmitter<QueryParamsItem>();
  @Output() actionTriggered = new EventEmitter<HandleActionDto<T>>();
  @Output() syncTriggered = new EventEmitter<void>();
  drawerVisible: boolean = false;

  syncButtonLoading: boolean = false;

  constructor(
    private featureFlagsService: FeatureFlagsService,
    private utilService: UtilService
  ) {
    this.title = '';
    this.tableState = {
      data: [],
      totalCount: 0,
      hasNextPage: false,
      hasPreviousPage: false,
      pageNumber: 1,
      pageSize: 50,
      loading: true
    };
    this.columns = [];
  }

  ngOnInit() {
    if (this.drawerClosed) {
      this.drawerClosed.subscribe((isClosed: boolean) => {
        if (isClosed) {
          this.closeDrawer();
        }
      });
    }
    if (this.syncLoadingChange) {
      this.syncLoadingChange.subscribe((syncValue: boolean) => {
        this.syncButtonLoading = syncValue;
      });
    }
  }

  onQueryParamsChange(params: QueryParamsItem): void {
    this.queryParamsChange.emit(params);
  }

  onActionTriggered(event: { action: EPossibleActionsEnum; item: T }): void {
    this.actionTriggered.emit(event);

    switch (event.action) {
      case EPossibleActionsEnum.EDIT:
      case EPossibleActionsEnum.RESET_PASSWORD:
        this.openDrawer();
        break;
      case EPossibleActionsEnum.DELETE:
        this.closeDrawer();
        break;
      default:
        break;
    }
  }

  openDrawer(): void {
    this.drawerVisible = true;
  }

  closeDrawer(): void {
    this.drawerVisible = false;
  }

  isFeatureEnabled(featureKey: string): boolean {
    return this.featureFlagsService.isFeatureEnabled(featureKey);
  }

  syncEntities() {
    this.syncTriggered.emit();
  }

  get isAnyActionLoading(): boolean {
    return this.utilService.isPageLoading([this.syncButtonLoading, this.externalLoadingState]);
  }

  get isSyncLoading(): boolean {
    return this.utilService.isPageLoading([this.syncButtonLoading]);
  }
}
